(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'restangular', 'ui.router', 'ui.bootstrap', 'toastr']);

})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('fixed', fixed);

  /** @ngInject */
  function fixed() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/fixed/fixed.html',
      scope: {
          title: '=',
          subtitle: '=',
          imageurl: '=',
          source: '=',
          tooltipnum: '=',
          tooltiptext: '='
      },
      controller: fixedController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function fixedController($timeout) {
      var vm = this;

      $timeout(function () {
        angular.element('sup.tooltippedGraph').tooltip({
          delay: 50
        });
      }, 0);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart6', chart6);

  /** @ngInject */
  function chart6() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart6/chart6.html',
      scope: {
          scrolling: '='
      },
      controller: chart6Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart6Controller($timeout) {
      var vm = this;

      $timeout(function() {
        d3.csv('assets/data/3_1_hombrestipoempleo.csv', function(csvData){

          var y = d3.scaleLinear()
            .range([420, 30])
            .domain([0, 100])

          d3.select('.chart6').selectAll('.barras_tooltip rect')
          .on('mouseover', function(d){
            var selectedAge = d3.select(this).attr('value');
            var tooltipData = _.find(csvData, function(dataRow){return dataRow.Edad == selectedAge});

            var xPos = +d3.select(this).attr('x') + (d3.select(this).attr('width')/2);
            d3.select('.chart6 svg')
              .append('line')
                .attr('class','line-hover')
                .attr('x1', xPos)
                .attr('y1',0)
                .attr('x2', xPos)
                .attr('y2', 420)
                .attr('stroke','#999')

            d3.select('.chart6 svg')
              .append('rect')
                .attr('class', 'tooltipD3')
                .attr('x', xPos)
                .attr('y', function(){
                  return y(tooltipData.Asalariados) -25;
                })
                .attr('width', 50)
                .attr('height', 35)
                .attr('fill', 'black')
                .attr('fill-opacity', 0.8)
                .attr('rx', 5)
                .attr('ry', 5);

            d3.select('.chart6 svg')
              .append('rect')
                .attr('class', 'tooltipD3')
                .attr('x', xPos)
                .attr('y', function(){
                  return y(tooltipData.Autonomos) -30;
                })
                .attr('width', 50)
                .attr('height', 35)
                .attr('fill', 'black')
                .attr('fill-opacity', 0.8)
                .attr('rx', 5)
                .attr('ry', 5);

            d3.select('.chart6 svg')
              .append('rect')
                .attr('class', 'tooltipD3')
                .attr('x', xPos)
                .attr('y', function(){
                  return y(tooltipData.Empresarios) -15;
                })
                .attr('width', 50)
                .attr('height', 35)
                .attr('fill', 'black')
                .attr('fill-opacity', 0.8)
                .attr('rx', 5)
                .attr('ry', 5);

            d3.select('.chart6 svg')
              .append('text')
                .attr('class', 'tooltipD3')
                .attr('x', xPos + 12)
                .attr('y', function(){
                  return y(tooltipData.Asalariados);
                })
                .attr('width', 200)
                .attr('height', 50)
                .attr('fill', 'white')
                .html(function(){
                    return d3.format(',.1f')(tooltipData.Asalariados);
                  });

            d3.select('.chart6 svg')
              .append('text')
                .attr('class', 'tooltipD3')
                .attr('x', xPos + 12)
                .attr('y', function(){
                  return y(tooltipData.Autonomos)-5;
                })
                .attr('width', 200)
                .attr('height', 50)
                .attr('fill', 'white')
                .html(function(){
                    return d3.format(',.1f')(tooltipData.Autonomos);
                  });

            d3.select('.chart6 svg')
              .append('text')
                .attr('class', 'tooltipD3')
                .attr('x', xPos + 12)
                .attr('y', function(){
                  return y(tooltipData.Empresarios)+10;
                })
                .attr('width', 200)
                .attr('height', 50)
                .attr('fill', 'white')
                .html(function(){
                    return d3.format(',.1f')(tooltipData.Empresarios);
                  });
          })
          .on('mouseout',function(d){
            d3.select('.chart6 svg').selectAll('.line-hover, .tooltipD3').remove();
          });

        });
      }, 2000);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart3', chart3);

  /** @ngInject */
  function chart3() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart3/chart3.html',
      scope: {
      },
      controller: chart3Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart3Controller($timeout) {
      var vm = this;

      vm.showWomen = function(){
        console.log(vm.switch);
        if(vm.switch)
          d3.select('.chart3 g#mujeres').style('visibility','visible');
        else
          d3.select('.chart3 g#mujeres').style('visibility','hidden');
      };
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart5', chart5);

  /** @ngInject */
  function chart5() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart5/chart5.html',
      scope: {
          scrolling: '='
      },
      controller: chart5Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart5Controller($timeout) {
      var vm = this;

      $timeout(function() {
        d3.csv('assets/data/3_1_mujerestipoempleo.csv', function(csvData){

          var y = d3.scaleLinear()
            .range([420, 20])
            .domain([0, 100])

          d3.select('.chart5').selectAll('.barras_tooltip rect')
          .on('mouseover', function(d){
            var selectedAge = d3.select(this).attr('value')
            var tooltipData = _.find(csvData, function(dataRow){return dataRow.Edad == selectedAge});

            var xPos = +d3.select(this).attr('x') + (d3.select(this).attr('width')/2);
            d3.select('.chart5 svg')
              .append('line')
                .attr('class','line-hover')
                .attr('x1', xPos)
                .attr('y1',0)
                .attr('x2', xPos)
                .attr('y2', 420)
                .attr('stroke','#999')

            d3.select('.chart5 svg')
              .append('rect')
                .attr('class', 'tooltipD3')
                .attr('x', xPos)
                .attr('y', function(){
                  return y(tooltipData.Asalariadas) -25;
                })
                .attr('width', 50)
                .attr('height', 35)
                .attr('fill', 'black')
                .attr('fill-opacity', 0.8)
                .attr('rx', 5)
                .attr('ry', 5);

            d3.select('.chart5 svg')
              .append('rect')
                .attr('class', 'tooltipD3')
                .attr('x', xPos)
                .attr('y', function(){
                  return y(tooltipData.Autonomas) -25;
                })
                .attr('width', 50)
                .attr('height', 35)
                .attr('fill', 'black')
                .attr('fill-opacity', 0.8)
                .attr('rx', 5)
                .attr('ry', 5);

            d3.select('.chart5 svg')
              .append('rect')
                .attr('class', 'tooltipD3')
                .attr('x', xPos)
                .attr('y', function(){
                  return y(tooltipData.Empresarias) -25;
                })
                .attr('width', 50)
                .attr('height', 35)
                .attr('fill', 'black')
                .attr('fill-opacity', 0.8)
                .attr('rx', 5)
                .attr('ry', 5);

            d3.select('.chart5 svg')
              .append('text')
                .attr('class', 'tooltipD3')
                .attr('x', xPos+12)
                .attr('y', function(){
                  return y(tooltipData.Asalariadas);
                })
                .attr('width', 200)
                .attr('height', 50)
                .attr('fill', 'white')
                .html(function(){
                    return d3.format(',.1f')(tooltipData.Asalariadas);
                  });

            d3.select('.chart5 svg')
              .append('text')
                .attr('class', 'tooltipD3')
                .attr('x', xPos + 12)
                .attr('y', function(){
                  return y(tooltipData.Autonomas);
                })
                .attr('width', 200)
                .attr('height', 50)
                .attr('fill', 'white')
                .html(function(){
                    return d3.format(',.1f')(tooltipData.Autonomas);
                  });

            d3.select('.chart5 svg')
              .append('text')
                .attr('class', 'tooltipD3')
                .attr('x', xPos + 12)
                .attr('y', function(){
                  return y(tooltipData.Empresarias);
                })
                .attr('width', 200)
                .attr('height', 50)
                .attr('fill', 'white')
                .html(function(){
                    return d3.format(',.1f')(tooltipData.Empresarias);
                  });  
          })
          .on('mouseout',function(d){
            d3.select('.chart5 svg').selectAll('.line-hover, .tooltipD3').remove();
          });
        });
      }, 2000);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart4', chart4);

  /** @ngInject */
  function chart4() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart4/chart4.html',
      scope: {
          scrolling: '='
      },
      controller: chart4Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart4Controller($timeout) {
      var vm = this;

      $timeout(function() {
        d3.csv('assets/data/3_1_tasaactividad.csv', function(csvData){

          var y = d3.scaleLinear()
            .range([420, 20])
            .domain([0, 100])

          d3.select('.chart4').selectAll('.barras_tooltip rect')
          .on('mouseover', function(d){
            var selectedAge = d3.select(this).attr('value');
            var tooltipData = _.find(csvData, function(dataRow){return dataRow.Edad == selectedAge});

            //var xPos = +d3.select(this).attr('transform').replace('matrix(1 0 0 1 ','').split(' ')[0] + 10;
            var xPos = +d3.select(this).attr('x') + (d3.select(this).attr('width')/2);
            d3.select('.chart4 svg')
              .append('line')
                .attr('class','line-hover')
                .attr('x1', xPos)
                .attr('y1',0)
                .attr('x2', xPos)
                .attr('y2', 420)
                .attr('stroke','#999');

            d3.select('.chart4 svg')
              .append('rect')
                .attr('class', 'tooltipD3')
                .attr('x', xPos)
                .attr('y', function(){
                  return y(tooltipData.Hombres) -25;
                })
                .attr('width', 50)
                .attr('height', 35)
                .attr('fill', 'black')
                .attr('fill-opacity', 0.8)
                .attr('rx', 5)
                .attr('ry', 5);

            d3.select('.chart4 svg')
              .append('text')
                .attr('class', 'tooltipD3')
                .attr('x', xPos + 12)
                .attr('y', function(){
                  return y(tooltipData.Hombres);
                })
                .attr('width', 200)
                .attr('height', 50)
                .attr('fill', 'white')
                .html(function(){
                    return d3.format(',.1f')(tooltipData.Hombres);
                  });

            d3.select('.chart4 svg')
              .append('rect')
                .attr('class', 'tooltipD3')
                .attr('x', xPos)
                .attr('y', function(){
                  return y(tooltipData.Mujeres) -25;
                })
                .attr('width', 50)
                .attr('height', 35)
                .attr('fill', 'black')
                .attr('fill-opacity', 0.8)
                .attr('rx', 5)
                .attr('ry', 5);

            d3.select('.chart4 svg')
              .append('text')
                .attr('class', 'tooltipD3')
                .attr('x', xPos + 12)
                .attr('y', function(){
                  return y(tooltipData.Mujeres);
                })
                .attr('width', 200)
                .attr('height', 50)
                .attr('fill', 'white')
                .html(function(){
                    return d3.format(',.1f')(tooltipData.Mujeres);
                  });
          })
          .on('mouseout',function(d){
            d3.select('.chart4 svg').selectAll('.line-hover, .tooltipD3').remove();
          });

        });
      }, 2000);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart22', chart22);

  /** @ngInject */
  function chart22() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart22/chart22.html',
      scope: {
      },
      controller: chart22Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart22Controller($timeout) {
      var vm = this;
      vm.sel = 1;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart21', chart21);

  /** @ngInject */
  function chart21() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart21/chart21.html',
      scope: {
      },
      controller: chart18Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart18Controller($timeout) {
      var vm = this;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart2', chart2);

  /** @ngInject */
  function chart2() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart2/chart2.html',
      scope: {
      },
      controller: chart2Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart2Controller($timeout) {
      var vm = this;

      vm.showWomen = function(){
        console.log(vm.switch);
        if(vm.switch)
          d3.select('.chart2 g#mujeres').style('visibility','visible');
        else
          d3.select('.chart2 g#mujeres').style('visibility','hidden');
      };
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart18', chart18);

  /** @ngInject */
  function chart18() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart18/chart18.html',
      scope: {
      },
      controller: chart18Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart18Controller($timeout) {
      var vm = this;
      vm.filterData = filterData;
      vm.showModal = showModal;
      vm.closeModal = closeModal;

      var width = 800,
          height = 500;

      var projection = d3.geoMercator()
          .scale(120)
          .translate([width / 2 - 45, 3 * height / 4  - 30])
          .precision(.1);

      var path = d3.geoPath()
          .projection(projection);

      var svg = d3.select('chart18 .chart-content .col.s12').append("svg")
          .attr("width", width)
          .attr("height", height);

      var countries = svg.append("g")
          .attr("id", "countries")

      var countriesDefault;

      var colorScale = d3.scaleLinear().range(['#FFF4D4','#ECBB1D','#BF7100']);

      var tip = d3.tip().attr('class','d3-tip').html(function(d){ return '<span>' + d.pais + '</span><br><span>' + (d.semanas_de_licencia) + ' semanas de licencia</span>'; })
      svg.call(tip);

      d3.json('assets/data/world-50m.v1.json', function (world) {
        d3.csv('assets/data/4_mapa.csv', function(d){
          d.semanas_de_licencia = +d.semanas_de_licencia;
          return d;
        }, function(data) {
          vm.data = data;
          var maxMin = d3.extent(data, function(o){ return o.semanas_de_licencia;});
          vm.maxMin = maxMin;
          colorScale.domain([maxMin[0], maxMin[0] + ((maxMin[1] - maxMin[0]) / 2), maxMin[1]]);

          angular.element("#rangeSelector").ionRangeSlider({
              min: maxMin[0],
              max: maxMin[1],
              from: maxMin[0],
              to: maxMin[1],
              type: 'double',
              grid: true,
              grid_num: 10,
              onFinish: function(data){
                vm.min = data.from;
                vm.max = data.to;
              }
          });

          vm.min = maxMin[0];
          vm.max = maxMin[1];

          vm.licenses = d3.map();
          data.forEach(function(o){
            vm.licenses.set(o.id, o);
          });

          countries.selectAll("path.country")
            .data(topojson.feature(world, world.objects.countries).features)
            .enter()
            .append('path')
              .attr("class", "country")
              .attr("d", path)
              .attr('id', function(d){ return 'p' + d.id})
              .attr('fill', function(d){ return 'steelblue'; });

          countriesDefault = countries.selectAll("path").data();
          filterData();
          //Resets the map "Estados" path data to topojson
          countries.selectAll("path").data(countriesDefault, function(d){ return  d.id; });

        });
      });

      function showModal(){
        vm.modal = true;
      }

      function closeModal(){
        vm.modal = false;
        vm.filterData();
      }

      function draw(){
        countries.selectAll("path").attr("stroke","#333").attr('stroke-width', 0.2);
        countries.selectAll("path").attr("fill", "#808080");
        countries.selectAll("path").attr('data-total', null);
        countries.selectAll("path")
            .data(vm.filtereddata, function(d){
              if(d.id == '036')
                console.log(d);
              return  d.id; })
            .attr('fill', function(d){
              return colorScale(d.semanas_de_licencia);
            })
            .attr('data-total', function(d){
                return d.total;
            })
            .attr('stroke-width', 1 )
            .attr('stroke', '#ccc')
            .on('mouseover', function(d){
              tip.show(vm.licenses.get(d.id), this);
            })
            .on('mouseout', tip.hide);
      }

      function filterData(){
        vm.filtereddata = _.filter(vm.data, function(o){ return o.semanas_de_licencia >= vm.min && o.semanas_de_licencia <= vm.max; })
        draw();
      }

      function getColor(d){
        var total = parseFloat(d.semanas_de_licencia);
        var color = '';
        if(total <= 58){
          color =  "#f7c7c5";
        }

        if(total <= 16){
          color =  "#ex65158";
        }

        if(total <= 14){
          color =  "#c20216";
        }

        if(total <= 12){
          color =  "#750000";
        }

        if(total <=4){
          color =  "#480000";
        }

        if(isNaN(total)){
          color = '#808080';
        }

        return color;
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart17', chart17);

  /** @ngInject */
  function chart17() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart17/chart17.html',
      scope: {
          scrolling: '='
      },
      controller: chart17Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart17Controller($timeout) {
      var vm = this;

      $timeout(function(){
        var data = [44.2, 46.8, 48.1, 46.4, 46.1, 45.5];
        var tip = d3.tip().attr('class', 'd3-tip').html(function(d){ return d;})
        var svg = d3.select('.chart17 svg');
        svg.call(tip);
        svg.selectAll('.circles .dot')
          .data(data)
          .on('mouseover', function(d){
            tip.show(d, this);
          })
          .on('mouseout', function(d){
            tip.hide();
          })
      }, 2000);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart16', chart16);

  /** @ngInject */
  function chart16() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart16/chart16.html',
      scope: {
          scrolling: '='
      },
      controller: chart16Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart16Controller($timeout) {
      var vm = this;

      /*
      $timeout(function(){
        d3.select('.chart16 #button-all')
          .style('cursor','pointer')
          .on('click', function(d){
            d3.selectAll('.chart16 .layer')
              .attr('visibility','visible');
            d3.selectAll('.chart16 .button-toggle-layer')
              .attr('opacity',1)
          });

        d3.selectAll('.chart16 .button-toggle-layer')
          .style('cursor','pointer')
          .on('click', function(d){
            var target = '#x' + d3.select(this).attr('id').replace('s','');
            if(d3.select('.chart16 ' + target).attr('visibility') == 'visible') {
              d3.select('.chart16 ' + target).attr('visibility', 'hidden');
              d3.select(this).attr('opacity', 0.5);
            } else {
              d3.select('.chart16 ' + target).attr('visibility','visible');
              d3.select(this).attr('opacity', 1);
            }
          });

        var width = $('.chart16 #colores')[0].getBoundingClientRect().width;
        var height = $('.chart16 #colores')[0].getBoundingClientRect().height;
        var margin_top = 120;

        d3.csv('assets/data/16_licencias.csv',
          function(d) {
            d.value = +d.value;
            return d;
          },function(data) {

          for(var year = 2010; year <= 2015; year ++) {
            var sum = 0;
            data.forEach(function(o){
              if(o.year == year) {
                sum += o.value;
                o.y2 = sum;
              }
            });
          }

          var yScale = d3.scaleLinear()
              .range([height, margin_top])
              .domain([0, d3.max(data, function(d){ return d.y2;})])

          d3.selectAll('.chart16 .x.axis .tick text')
              .style('cursor','pointer')
              .on('mouseover', function(d,i) {
                var year = d3.select(this).html();
                var xPos = +d3.select(this).attr('transform').replace('matrix(1 0 0 1 ','').split(' ')[0] + 25;
                var filtered = _.filter(data, function(o){ return o.year == year;});
                d3.select('.chart16 svg')
                  .selectAll('.ttip')
                  .data(filtered)
                  .enter()
                  .append('text')
                    .attr('class','ttip')
                    .attr('text-anchor','middle')
                    .attr('x', xPos)
                    .attr('y', function(d){ return yScale(d.y2); })
                    .text(function(d){ return d.value;})
              })
              .on('mouseout', function(d,i) {
                d3.selectAll('.chart16 svg .ttip').remove();
              });
        });
      }, 2000);
      */
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart12', chart12);

  /** @ngInject */
  function chart12() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart12/chart12.html',
      scope: {
          scrolling: '='
      },
      controller: chart12Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart12Controller($timeout) {
      var vm = this;


      $timeout(function(){
        d3.csv('assets/data/3_3_gastoinfancia.csv', function(csvData){

          var y = d3.scaleLinear()
            .range([430, 130])
            .domain([0,400000])

          d3.select('.chart12').selectAll('.barras_tooltip rect')
            .on('mouseover', function(d){
              var selectedStage = d3.select(this).attr('value');
              console.log(selectedStage);
              var tootlipData = _.find(csvData, function(dataRow){return dataRow.Etapa == selectedStage})
      
              console.log(tootlipData);
              var xPos = +d3.select(this).attr('x') + (d3.select(this).attr('width')/2);

              d3.select('.chart12 svg')
                .append('text')
                  .attr('class', 'd3-tip ctip')
                  .attr('x', xPos-25)
                  .attr('y', function(){
                    return y(tootlipData.Mexico) + 10
                  })
                  .attr('width', 200)
                  .attr('height', 50)
                  .html(function(){
                    return d3.format(',.1f')(tootlipData.Mexico)
                  });

              d3.select('.chart12 svg')
                .append('text')
                  .attr('class', 'd3-tip ctip')
                  .attr('x', xPos-25)
                  .attr('y', function(){
                    return y(tootlipData.OCDE)
                  })
                  .attr('width', 200)
                  .attr('height', 50)
                  .html(function(){
                    return d3.format(',.1f')(tootlipData.OCDE);
                  });

            })
            .on('mouseout', function(d){
              d3.select('.chart12 svg').selectAll('.line-hover, .d3-tip').remove();

            })
        })
      }, 2000);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('chart1', chart1);

  /** @ngInject */
  function chart1() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/charts/chart1/chart1.html',
      scope: {
          scrolling: '='
      },
      controller: chart1Controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function chart1Controller($timeout) {
      var vm = this;

      vm.drop1 = [
        {
          name: 'Hacer las compras',
          src: 'assets/images/cap1/tareas_hogar/hacer-las-compras.png'
        },{
          name: 'Hacer limpieza',
          src: 'assets/images/cap1/tareas_hogar/hacer-limpieza.png'
        },{
          name: 'Preparar alimentos',
          src: 'assets/images/cap1/tareas_hogar/preparar-alimentos.png'
        }
      ];

      vm.drop2 = [
        {
          name: 'Menores de 6 años (sin discapacidad)',
          src: 'assets/images/cap1/cuidado_personas/menores_de_6.png'
        },{
          name: 'Menores de 6 a 14 años (sin discapacidad)',
          src: 'assets/images/cap1/cuidado_personas/menores_de_6_a_14.png'
        },{
          name: 'Mayores de 60 años (sin discapacidad)',
          src: 'assets/images/cap1/cuidado_personas/mayores_de_60.png'
        },{
          name: 'Personas con discapacidad',
          src: 'assets/images/cap1/cuidado_personas/discapacidad.png'
        },{
          name: 'Personas enfermas',
          src: 'assets/images/cap1/cuidado_personas/enfermos.png'
        }
      ];

      vm.selected1 = vm.drop1[0].src;
      vm.selected2 = vm.drop2[0].src;

      $timeout(function(){
        angular.element('select').material_select();
        d3.selectAll('.caret').text('');
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .controller('ListChaptersController', ListChaptersController);

  /** @ngInject */
  function ListChaptersController($chaptersService) {
    var vm = this;

    vm.editSubchaps = false;

    $chaptersService.getEditChapters().then(function(chapters){
      vm.chapters = chapters;
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .controller('EditSubchapterController', EditSubchapterController);

  /** @ngInject */
  function EditSubchapterController($chaptersService,$stateParams, imagetools_cors_hosts) {
    var vm = this;

    vm.editSubchaps = false;

    vm.saveSubchap = function (){
      $chaptersService.updateSubChapters($stateParams.chapterId,vm.chapter.subchapters).then(function(data){
        console.log("lel",data);
      });
    }

    vm.tinymceOptions = {
      language: 'es_MX',
      language_url: '/assets/languages/tinymce-es_MX.js',
      theme: 'inlite',
      inline: true,
      insert_toolbar: 'insert',
      selection_toolbar: 'bold italic | quicklink h2 h3 h4',
      plugins: 'image media link paste contextmenu textpattern autolink imagetools',
      image_title: true,
      imagetools_cors_hosts: imagetools_cors_hosts,
      automatic_uploads: false,
      paste_data_images: true,
      file_picker_types: 'image',
      external_plugins: {
        'grafic': '/assets/plugins/grafic.js'
      },
      images_upload_handler: function (blobInfo, success, failure) {
        callback_images_upload_handler(blobInfo, success, failure);
      },
      file_picker_callback: function (cb, value, meta) {
        callback_file_picker_callback(cb, value, meta);
      },
      init_instance_callback: function (editor) {
        callback_init_instance_callback(editor);
      },
    };

    $chaptersService.getOneChapter($stateParams.chapterId).then(function(chapter){
      vm.chapter = chapter;
      vm.subchapter = chapter.subchapters[$stateParams.subchapterId];
      console.log(vm.subchapter);
    });

    function callback_images_upload_handler(blobInfo, success, failure) {
      var formData = new FormData();
      formData.append('file', blobInfo.blob());

      Restangular.all('uploadfile')
        .withHttpConfig({ transformRequest: angular.identity })
        .customPOST(formData, 'upload', undefined, { 'Content-Type': undefined })
        .then(function (res) {
          success(res);
        })
        .catch(function (err) {
          console.log(err);
          failure(err);
        });
    }

    function callback_file_picker_callback(cb, value, meta) {
      var input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.onchange = function () {
        var file = this.files[0];
        var id = 'blobid' + (new Date()).getTime();
        var blobCache = tinymce.activeEditor.editorUpload.blobCache;
        var blobInfo = blobCache.create(id, file);

        blobCache.add(blobInfo);

        cb(blobInfo.blobUri(), { title: file.name });
      };

      input.click();
    }

    function callback_init_instance_callback(editor) {
      tinymce.activeEditor.setContent(vm.subchapter.content);
    }

    var guid = function(prefix) {
      var counter = 0;
      return function() {
          var guid = new Date().getTime().toString(32);
          return prefix + guid + (counter++).toString(32);
      };
    };

    var tocId = guid('mcetoc_');

  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .controller('EditChapterController', EditChapterController);

  /** @ngInject */
  function EditChapterController($chaptersService,$stateParams) {
    var vm = this;

    vm.editSubchaps = false;
    $chaptersService.getOneChapter($stateParams.id).then(function(chapter){
      vm.chapter = chapter;
    });

    vm.delSubChap = function(idx){

      var txt;
      var r = confirm("Ésta acción no podrá revertirse. ¿Desea continuar?");
      if (r == true) {

        if(idx === 0){
          vm.chapter.subchapters.shift();
          vm.chapter.subchapters[0].first = true;
        }else{
          if(idx === vm.chapter.subchapters.length - 1){
            vm.chapter.subchapters.pop();
            vm.chapter.subchapters[vm.chapter.subchapters.length - 1].last = true;
          }else{
            vm.chapter.subchapters.splice(idx,1);
          }
        }

        $chaptersService.updateSubChapters($stateParams.id,vm.chapter.subchapters).then(function(data){
          console.log("lel",data);
        })

      }

    }

  }
})();

(function() {
    'use strict';

    angular
        .module('gireLaboralReproductiva')
        .factory('$chaptersService', chaptersService);


    /** @ngInject */
    function chaptersService($q,Restangular,$anchorScroll,$location,$window,$sce) {
      var service = {
        getChapters: getChapters,
        getEditChapters: getEditChapters,
        getOneChapter: getOneChapter,
        updateSubChapters: updateSubChapters
      };

      function Subchapter(name,num,content,chapNum){
        this.name = name;
        this.num = num;
        if(name === 'NOTAS'){
          this.formattedChapter = '';
        }else{
          this.formattedChapter = chapNum + "." + num;
        }

        this.first = false;
        this.last = false;
        this.content = content;
      }

      function Chapter(name,num,id,intro){
        this.intro = intro;
        this.name = name;
        this.num = num;
        this.mongoId = id;
        this.subchapters = [];
        this.first = false;
        this.last = false;
        this.addSubChapter = function(subchap){
          subchap.chapter = this.num;

          if(this.subchapters.length === 0){
            subchap.first = true;
            subchap.last = true;
            this.subchapters.push(subchap);
          }else{

            this.subchapters[this.subchapters.length - 1].last = false;

            subchap.last = true;

            this.subchapters.push(subchap);

          }

        };
      }

      function Book(){
        this.chapters = [];
        this.currentChap = 1;
        this.currentSubChap = 1;
        this.selectedChapter = null;
        this.selectedSubChapter = null;

        this.setCurrent = function(chap,subchap){

          this.currentChap = (angular.isDefined(chap)) ? +chap - 1: this.currentChap;
          this.currentSubChap = (angular.isDefined(subchap)) ? +subchap - 1: this.currentSubChap;

          this.selectedChapter = this.chapters[this.currentChap];

          this.selectedSubChapter = this.chapters[this.currentChap].subchapters[this.currentSubChap];

        }

        this.goForward = function(){

          var deferred = $q.defer();

          if(this.selectedSubChapter.last){
            this.currentSubChap = 0;

            if(!this.selectedChapter.last){

              this.chapters[this.currentChap].subchapters = [];

              this.currentChap += 1;

              var self = this;

              return Restangular.one('chapter', this.chapters[this.currentChap].mongoId).getList('subchapters').then(function(data){

                var datAUx = _.sortBy(data.plain(),function(d){
                  return d.num;
                });

                datAUx.forEach(function(subchapter){

                  var auxSubChap = new Subchapter(subchapter.name,subchapter.num, $sce.getTrustedHtml(subchapter.content), self.currentChap + 1);

                  self.chapters[self.currentChap].addSubChapter(auxSubChap);

                });

                $window.scrollTo(0, 0);

                self.setCurrent();

                return self.selectedSubChapter;
              });

            }else{
              deferred.resolve(this.selectedSubChapter);
              return deferred.promise;
            }

          }else{
            this.currentSubChap += 1;
            this.setCurrent();
            $location.hash("ch" + (this.currentChap + 1) + "sub" + (this.currentSubChap + 1));
            $anchorScroll();
            deferred.resolve(this.selectedSubChapter);
            return deferred.promise;
          }
        }

        this.goBack = function(){
          var deferred = $q.defer();

          if(this.selectedSubChapter.first){
            if(this.selectedChapter.first){
              deferred.resolve(this.selectedSubChapter);
              return deferred.promise;

            }else{

              this.chapters[this.currentChap].subchapters = [];

              this.currentChap -= 1;

              var self = this;

              return Restangular.one('chapter', this.chapters[this.currentChap].mongoId).getList('subchapters').then(function(data){

                self.currentSubChap = data.plain().length - 1;

                var datAUx = _.sortBy(data.plain(),function(d){
                  return d.num;
                });
                datAUx.forEach(function(subchapter){

                  var auxSubChap = new Subchapter(subchapter.name,subchapter.num, $sce.getTrustedHtml(subchapter.content) , self.currentChap + 1);

                  self.chapters[self.currentChap].addSubChapter(auxSubChap);

                });

                $location.hash("ch" + (self.currentChap + 1) + "sub" + (self.currentSubChap + 1));
                $anchorScroll();

                self.setCurrent();

                return self.selectedSubChapter;
              });

            }
          }else{
            this.currentSubChap = (this.currentSubChap > 0) ? this.currentSubChap - 1 : this.currentSubChap;
            this.setCurrent();
            $location.hash("ch" + (this.currentChap + 1) + "sub" + (this.currentSubChap + 1));
            $anchorScroll();
            deferred.resolve(this.selectedSubChapter);
            return deferred.promise;
          }
        }

        this.addChapter = function(chapter){
          if(this.chapters.length === 0){
            chapter.first = true;
            chapter.last = true;
            this.chapters.push(chapter);
          }else{

            this.chapters[this.chapters.length - 1].last = false;

            chapter.last = true;

            this.chapters.push(chapter);

          }
        }
      }

      function getEditChapters(){
        var deferred = $q.defer();

        Restangular.all('edit/chapters').getList()  // GET: /users
        .then(function(data) {
          deferred.resolve(data.plain());
        });

        return deferred.promise;
      }

      function getOneChapter(chapterId){
        var deferred = $q.defer();

        Restangular.one('chapter',chapterId).get()
        .then(function(data) {
          deferred.resolve(data.plain());
        });

        return deferred.promise;
      }

      function updateSubChapters(chapId,subchapters){
        var deferred = $q.defer();

        Restangular.one('chapter',chapId).all('subchapters').post({subchaps: subchapters})
        .then(function(data) {
          deferred.resolve(data);
        });

        return deferred.promise;
      }

      function getChapters(chap,subchap){

        var deferred = $q.defer();

        Restangular.all('chapters').getList()  // GET: /users
        .then(function(data) {

          var book = new Book();
          var datAUx = _.sortBy(data.plain(),function(d){
              return d.num;
            });
            datAUx.forEach(function(chapter){

            var auxChap = new Chapter(chapter.name,chapter.num,chapter._id,chapter.intro);

            book.addChapter(auxChap);

          });

          var chapter = book.chapters[chap - 1];

          Restangular.one('chapter', chapter.mongoId).getList('subchapters').then(function(data){
            var datAUx = _.sortBy(data.plain(),function(d){
              return d.num;
            });
            datAUx.forEach(function(subchapter){

              var auxSubChap = new Subchapter(subchapter.name,subchapter.num, $sce.getTrustedHtml(subchapter.content),  chapter.num);

              chapter.addSubChapter(auxSubChap);

            });

            book.setCurrent(chap,subchap);

            deferred.resolve(book);
          });

        });

        return deferred.promise;
      }

      function testAdd(){

        var test ={
             name: 'LEL 4',
            num: 4
          };
        Restangular.all("chapters/add").post(test).then(function(data){
          console.log(data.plain());
        });
      }

      //testAdd();


      function testAdd2(){

        var test ={
                name: 'Un poco de LEL',
                num: 4,
                content: 'LEL 4'
              };

        test.chapterMongoId = "58cc35765d7574022c90afcf";

        Restangular.one('chapter', test.chapterMongoId).all('subchapter/add').post(test).then(function(data){
          console.log(data);
        });
      }

      //testAdd2();

      return service;
    }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($stateParams,$chaptersService,$scope,$timeout,$sce, $compile, $window) {
    var vm = this;

    var localBook;

    $chaptersService.getChapters($stateParams.chap,$stateParams.subchap).then(function(book){
      localBook = book;
      vm.chapters = localBook.chapters;
      vm.currentChap = localBook.selectedChapter;
      vm.currentSubChap = localBook.selectedSubChapter;

      $timeout(function(){
        //console.log('chaptersService',localBook, vm.currentChap)
        setTooltips(vm.currentChap);

      },100);

    });

    angular.element('.modal').modal();

    vm.showModalVideo = function(){
      /* Each time modal opens*/
      var url = 'https://www.youtube.com/embed/1iYFVEQWcJk?showinfo=0&autoplay=1';
      $("#video-gire").attr('src', url);
      $('#modalVideo').modal('open');
      /* Set height of modal based on header and content height */
        var height = 2 * $('#modalVideo .modal-header')[0].clientHeight + $('#modalVideo .modal-content')[0].clientHeight
        d3.select('#modalVideo').style('height', height + 'px');
    }

    vm.closeModal = function(){
      $('#modalVideo').modal('close');
      $("#video-gire").attr('src', '');
    }
    vm.openCiteModal = function(content){

  var today = new Date().toLocaleDateString('es-MX');

  vm.citationText =
       'Grupo de Información en Reproducción Elegida (GIRE). ' +
  'Horas hábiles. ' +
  'Corresponsabilidad en la vida laboral y personal. ' +
  '2017. ' +
  'https://corresponsabilidad.gire.org.mx/#/chapter/1/subchapter/1';

    $('#modalCite').modal('open');
  };

  vm.closeCiteModal = function(){
    $('#modalCite').modal('close');
  };

  vm.copyCitation = function(){
    var temp = document.createElement('textarea');
    temp.value = vm.citationText;
    document.body.appendChild(temp);
    temp.select();
    document.execCommand('copy');
    document.body.removeChild(temp);
  };


    vm.updateChapter = function(key){
      //console.log(localBook[key]);
      localBook[key]().then(function(subchapter){
        vm.currentSubChap = subchapter;
        vm.currentChap = localBook.selectedChapter;
        $timeout(function(){
          setTooltips();
        },100);
      });
    }

    function setTooltips(currentChap){
      if(currentChap && currentChap.num <= 5){
        d3.selectAll('sup.tooltipped')
          .attr("data-position", "top")
          .attr("data-delay", "50")
          .attr("data-tooltip",function(d,i){
            var index = i+1;
            var text = d3.select("ol.notes li:nth-child("+index+")") ? d3.select("ol.notes li:nth-child("+index+")").text() : '';
            return text;
          })
        angular.element(".tooltipped").tooltip({delay: 50});
      }
    }

    angular.element($window).bind("scroll", function() {

      vm.scrollSpy = [];
      d3.selectAll('.breakpoint')
        .each(function(){
          var id = this.id;
          var preSub = this.id.replace("ch", "");
          var chAndSubArray = preSub.split("sub");

          vm.scrollSpy.push({
            ch: +chAndSubArray[0],
            subch: +chAndSubArray[1],
            scroll: this.offsetTop - 100
          });
      });

      var scrolled = this.pageYOffset
      vm.applyTopper = (this.pageYOffset > 0) ? true : false;
      angular.forEach(vm.scrollSpy, function(value, key){
        if(scrolled > value.scroll && vm.scrollSpy[key+1] === undefined){ //Last subchapter
          setCurrent(value.ch, value.subch);
        }
        else if(scrolled > value.scroll && scrolled < vm.scrollSpy[key+1].scroll){
          setCurrent(value.ch, value.subch);
        }
      });

      $scope.$apply();
      //console.log(this.pageYOffset);
    });

    function setCurrent(ch, sub){
      localBook.setCurrent(ch, sub);
          vm.chapters = localBook.chapters;
          vm.currentChap = localBook.selectedChapter;
          vm.currentSubChap = localBook.selectedSubChapter;
    }
    /*$timeout(function(){
      var titlesContainers = d3.selectAll(".row.subtitle-container");
      console.log(titlesContainers);
      titlesContainers.each(function(d,i){
        console.log(d,i);
      })
    },500);*/

    vm.renderCharts = function(content){
      $timeout(function(){
        var div = d3.select('#ch' + vm.currentChap.num + 'sub' + content.num);
        div.selectAll('.chart').each(function(d){
          var chartId = d3.select(this).attr('class').replace('chart ','').replace('hide ','');
          console.log(chartId);
          switch(chartId){
            // Cap 1
            case 'chart1': //HORAS DEDICADAS A LA SEMANA AL TRABAJO NO REMUNERADO (DOMÉSTICO Y DE CUIDADO)
              d3.select('.chart1').append('chart1');
              $compile(angular.element('.chart1').contents())($scope);
              break;
            case 'chart2':
              d3.select('.chart2').append('chart2');
              $compile(angular.element('.chart2').contents())($scope);

              break;
            case 'chart3':
              d3.select('.chart3').append('chart3');
              $compile(angular.element('.chart3').contents())($scope);
              break;
            // Cap 3
            case 'chart4': //TASA ACTIVIDAD POR SEXO VS EDAD
              d3.select('.chart4').append('chart4');
              $compile(angular.element('.chart4').contents())($scope);
              break;
            case 'chart5':
              d3.select('.chart5').append('chart5');
              $compile(angular.element('.chart5').contents())($scope);
              break;
            case 'chart6':
              d3.select('.chart6').append('chart6');
              $compile(angular.element('.chart6').contents())($scope);
              break;
            case 'chart7':
              d3.select('.chart7')
                .append('fixed')
                  .attr('title',"'DESCUENTO A PATRONES Y TRABAJADORES POR LEY'")
                  .attr('subtitle',"'DEL IMSS 2008 (REFORMA MÁS RECIENTE)'")
                  .attr('imageurl',"'assets/images/cap3/04 grafica.jpg'")
                  .attr('source',"")
              $compile(angular.element('.chart7').contents())($scope);
              break;
            case 'chart8':
              d3.select('.chart8')
                .append('fixed')
                  .attr('title',"'ESCENARIO 1. COSTOS LICENCIA DE PATERNIDAD Y MATERNIDAD'")
                  .attr('subtitle',"'COSTO POR INSTITUCIÓN EN MILLONES DE PESOS POR SEXO'")
                  .attr('imageurl',"'assets/images/cap3/05-estatica.png'")
                  .attr('source',"'Fuente: Pinedo, Luis, El costo de las licencias parentales en México, documento de trabajo, 2016, pp. 3-5, disponible en el sitio web de GIRE.'")
                  .attr('tooltipnum', "'22'")
                  .attr('tooltiptext', "'Íbidem, Tabla 3.'")
              $compile(angular.element('.chart8').contents())($scope);
              break;
            case 'chart9':
              d3.select('.chart9')
                .append('fixed')
                  .attr('title',"'ESCENARIO 2. COSTOS LICENCIA DE PATERNIDAD Y MATERNIDAD'")
                  .attr('subtitle',"'COSTO POR INSTITUCIÓN EN MILLONES DE PESOS POR SEXO'")
                  .attr('imageurl',"'assets/images/cap3/06-estatica.png'")
                  .attr('source', "'Fuente: Pinedo, Luis, El costo de las licencias parentales en México, documento de trabajo, 2016, pp. 3-5, disponible en el sitio web de GIRE.'")
                  .attr('tooltipnum', "'23'")
                  .attr('tooltiptext', "'Íbidem, Tabla 4.'")
              $compile(angular.element('.chart9').contents())($scope);
              break;
            case 'chart10':
              d3.select('.chart10')
                .append('fixed')
                  .attr('title',"'ESCENARIO 3. COSTOS LICENCIA DE PATERNIDAD Y MATERNIDAD'")
                  .attr('subtitle',"'COSTO POR INSTITUCIÓN EN MILLONES DE PESOS POR SEXO'")
                  .attr('imageurl',"'assets/images/cap3/07-estatica.png'")
                  .attr('source', "'Fuente: Pinedo, Luis, El costo de las licencias parentales en México, documento de trabajo, 2016, pp. 3-5, disponible en el sitio web de GIRE.'")
                  .attr('tooltipnum', "'24'")
                  .attr('tooltiptext', "'Íbidem, Tabla 5.'")
              $compile(angular.element('.chart10').contents())($scope);
              break;
            case 'chart11':
              d3.select('.chart11')
                .append('fixed')
                  .attr('title',"'ESCENARIO 4. COSTOS LICENCIA DE PATERNIDAD Y MATERNIDAD'")
                  .attr('subtitle',"'COSTO POR INSTITUCIÓN EN MILLONES DE PESOS POR SEXO'")
                  .attr('imageurl',"'assets/images/cap3/08-estatica.png'")
                  .attr('source', "'Fuente: Pinedo, Luis, El costo de las licencias parentales en México, documento de trabajo, 2016, pp. 3-5, disponible en el sitio web de GIRE.'")
                  .attr('tooltipnum', "'25'")
                  .attr('tooltiptext', "'Íbidem, Tabla 6.'")
              $compile(angular.element('.chart11').contents())($scope);
              break;
            case 'chart12':
              d3.select('.chart12').append('chart12');
              $compile(angular.element('.chart12').contents())($scope);
              break;
            // Cap 4
            case 'chart13':
              d3.select('.chart13') //4.1.2
                .append('fixed')
                  .attr('title',"'COMPOSICIÓN DE LA INFORMALIDAD LABORAL [21]'")
                  .attr('subtitle',"'MÉXICO 2013'")
                  .attr('imageurl',"'assets/images/cap4/13-switch.png'")
                  .attr('source',"'Fuente: Mujeres y hombres en México 2014, INEGI 2015'")
              $compile(angular.element('.chart13').contents())($scope);
              break;
            case 'chart14':
              d3.select('.chart14') //4.1.2
                .append('fixed')
                  .attr('title',"'PORCENTAJE DE TRABAJADORAS Y TRABAJADORES'")
                  .attr('subtitle',"")
                  .attr('imageurl',"'assets/images/cap4/14-switch.png'")
                  .attr('source',"'Fuente: Mujeres y hombres en México 2014, INEGI 2015'")
              $compile(angular.element('.chart14').contents())($scope);
              break;
            case 'chart15':
              d3.select('.chart15') //4.1.2
                .append('fixed')
                  .attr('title',"'AFILIACIÓN DE MUJERES A UN SERVICIO MÉDICO'")
                  .attr('subtitle',"'2013'")
                  .attr('imageurl',"'assets/images/cap4/15-estatica.png'")
                  .attr('source',"'Fuente: Elaboración de GIRE con base en la Encuesta Nacional de Empleo y Seguridad Social 2013.'")
              $compile(angular.element('.chart15').contents())($scope);
              break;
            case 'chart16':
              d3.select('.chart16').append('chart16');
              $compile(angular.element('.chart16').contents())($scope);
              break;
            case 'chart17':
              d3.select('.chart17').append('chart17');
              $compile(angular.element('.chart17').contents())($scope);
              break;
            case 'chart18': //SUPER MAPA
              d3.select('.chart18').append('chart18');
              $compile(angular.element('.chart18').contents())($scope);
              break;
            case 'chart19': // Tabla
              d3.select('.chart19') //4.3
                .append('fixed')
                  .attr('title',"'ELEMENTOS MÍNIMOS QUE DEBE CONTENER UN LACTARIO'")
                  .attr('subtitle',"")
                  .attr('imageurl',"'assets/images/cap4/19-estatica.jpg'")
                  .attr('source',"")
              $compile(angular.element('.chart19').contents())($scope);
            break;
            case 'chart20':
              d3.select('.chart20') //4.4
                .append('fixed')
                  .attr('title',"'CUIDADO DE NIÑOS'")
                  .attr('subtitle',"")
                  .attr('imageurl',"'assets/images/cap4/20-estatica.png'")
                  .attr('source',"'Fuente: Encuesta Nacional de Empleo y Seguridad Social 2013.'")
              $compile(angular.element('.chart20').contents())($scope);
              break;
            case 'chart21': //PRINCIPALES INSTITUCIONES PÚBLICAS DE CUIDADO Y SUS NORMATIVAS
              d3.select('.chart21').append('chart21');
              $compile(angular.element('.chart21').contents())($scope);
              break;
            case 'chart22':
              d3.select('.chart22').append('chart22');
              $compile(angular.element('.chart22').contents())($scope);
              break;
            case 'chart23':
              d3.select('.chart23')
                .append('fixed')
                  .attr('title',"'LICENCIAS PARA CUIDADOS MATERNOS O PATERNOS OTORGADAS POR LA CDHDF'")
                  .attr('subtitle',"")
                  .attr('imageurl',"'assets/images/cap4/23-estatica.jpg'")
                  .attr('source',"'Fuente: CDHDF. Sistema de Acceso a la Información Pública, folio 3200000070416.'")
              $compile(angular.element('.chart23').contents())($scope);
              break;
            case 'chart24':
              d3.select('.chart24')
                .append('fixed')
                  .attr('title',"'LICENCIAS PARA CUIDADOS MATERNOS O PATERNOS OTORGADAS POR EL INE (EMITIDAS POR EL ISSSTE)'")
                  .attr('subtitle',"")
                  .attr('imageurl',"'assets/images/cap4/24-estatica.jpg'")
                  .attr('source',"'Fuente: INE. Sistema de Accesmaternos a al Información Pública, folio 2210000043916.'")
              $compile(angular.element('.chart24').contents())($scope);
              break;
            case 'chart25':
              d3.select('.chart25')
                .append('fixed')
                  .attr('title',"'LICENCIAS PARA CUIDADOS MATERNOS O PATERNOS OTORGADAS POR INMUJERES'")
                  .attr('subtitle',"")
                  .attr('imageurl',"'assets/images/cap4/25-estatica.jpg'")
                  .attr('source',"'Fuente: Inmujeres. Sistema de Acceso a la Información Pública, folio 0610400018816.'")
              $compile(angular.element('.chart25').contents())($scope);
              break;
            case 'chart26':
              d3.select('.chart26')
                .append('fixed')
                  .attr('title',"'LICENCIAS PARA CUIDADOS MATERNOS O PATERNOS OTORGADAS POR INMUJERES CDMX'")
                  .attr('subtitle',"")
                  .attr('imageurl',"'assets/images/cap4/26-estatica.jpg'")
                  .attr('source',"'Fuente: Inmujeres CDMX. Sistema de Acceso a la Información Pública, folio 0313000022716.'")
              $compile(angular.element('.chart26').contents())($scope);
              break;
            case 'chart27':
              d3.select('.chart27')
                .append('fixed')
                  .attr('title',"'LICENCIAS PARA CUIDADOS MATERNOS O PATERNOS OTORGADAS POR CONAPRED'")
                  .attr('subtitle',"")
                  .attr('imageurl',"'assets/images/cap4/27-estatica.jpg'")
                  .attr('source',"'Fuente: Conapred. Sistema de Acceso a la Información Pública, folio 0441000014016.'")
              $compile(angular.element('.chart27').contents())($scope);
              break;
            // Cap 5
            case 'chart28':
              d3.select('.chart28')
                .append('fixed')
                  .attr('title',"'QUEJAS Y RECLAMACIONES SOBRE PRESUNTOS ACTOS'")
                  .attr('subtitle',"'DE DISCRIMINACIÓN POR MATERNIDAD O PATERNIDAD'")
                  .attr('imageurl',"'assets/images/cap5/01-estatica.png'")
                  .attr('source',"'FUENTE: CONAPRED. SISTEMA DE ACCESO A LA INFORMACIÓN PÚBLICA, FOLIO 011582016.'")
              $compile(angular.element('.chart28').contents())($scope);
              break;
            // END
            case 'chart29':
              break;
            case 'chart30':
              break;
            case 'chart31':
              break;
            case 'chart32':
              break;
          }
        });

        //console.log('renderCharts setTooltips ')
        //setTooltips();
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .controller('AdminController', AdminController);

  /** @ngInject */
  function AdminController() {
    var vm = this;

  }
})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log,Restangular,api) {
    Restangular.setBaseUrl(api);
    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      // .state('admin', {
      //   url: '/admin',
      //   templateUrl: 'app/admin/admin.html',
      //   controller: 'AdminController',
      //   controllerAs: 'admin'
      // })
      // .state('list-chapters', {
      //   parent: 'admin',
      //   url: '/list-chapters',
      //   templateUrl: 'app/admin/edit/list-chapters.html',
      //   controller: 'ListChaptersController',
      //   controllerAs: 'vm'
      // })
      // .state('edit-chapter', {
      //   parent: 'admin',
      //   url: '/edit-chapter/:id',
      //   templateUrl: 'app/admin/edit/edit-chapter.html',
      //   controller: 'EditChapterController',
      //   controllerAs: 'vm'
      // })
      // .state('edit-subchapter', {
      //   parent: 'admin',
      //   url: '/edit-subchapter/:chapterId/:subchapterId',
      //   templateUrl: 'app/admin/edit/edit-subchapter.html',
      //   controller: 'EditSubchapterController',
      //   controllerAs: 'vm'
      // })
      .state('main', {
        url: '/chapter/:chap/subchapter/:subchap',
        views: {
            '': {
              templateUrl: 'app/main/main.html',
              controller: 'MainController',
              controllerAs: 'main',
            },
            'indexBar@main': { templateUrl: 'app/components/index-bar/index-bar.html' }
        }
      });

    $urlRouterProvider.otherwise('/chapter/1/subchapter/1');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('api','/api/v1')
    .constant('imagetools_cors_hosts', ['localhost:3000']);

})();

  (function() {
  'use strict';

  angular
    .module('gireLaboralReproductiva')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("gireLaboralReproductiva").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=gire-container><div class=gire-bar></div><div class=gire-background><a href=https://gire.org.mx/ class=logo><img src=../../assets/images/logo_gire.svg alt=\"logo gire\"></a><div id=gire-button-container><a href=/assets/pdfs/VIDA_LABORAL_Y_REPRODUCTIVA.pdf download><button class=\"btn gire-button\"><h5 class=download-button>DESCARGAR PDF</h5></button> </a><a href=/assets/pdfs/RESUMEN_WEB.pdf download><button class=\"btn gire-button\" style=margin-left:2%><h5 class=download-button>DESCARGAR RESUMEN</h5></button> </a><a href=/assets/pdfs/checklist.pdf download><button class=\"btn gire-button\" style=margin-left:2%><h5 class=download-button>DESCARGAR CHECKLIST</h5></button> </a><a href=/assets/pdfs/OFFICEHOURS_210819_WEB.pdf download><button class=\"btn gire-button\" style=margin-left:3%><h5 class=download-button>DOWNLOAD SUMMARY</h5></button> </a><a ng-click=main.showModalVideo()><button class=\"btn gire-button\" style=margin-left:2%><h5 class=download-button>VER VIDEO</h5></button> </a><button class=\"btn gire-button\" style=margin-left:8%><a class=social-icon href=https://www.facebook.com/GrupodeInformacionenReproduccionElegida><i class=\"fa fa-facebook\" style=width:18px aria-hidden=true></i></a></button> <button class=\"btn gire-button\" style=margin-left:2%><a class=social-icon href=\"https://twitter.com/gire_mx?lang=es\"><i class=\"fa fa-twitter\" aria-hidden=true></i></a></button></div></div></div><div id=modalVideo class=modal><div class=modal-header><a ng-click=main.closeModal() class=\"modal-action modal-close waves-effect waves-green btn-flat\"><i class=\"small material-icons\">close</i></a></div><div class=modal-content><iframe id=video-gire width=853 height=480 src=\"\" frameborder=0 allowfullscreen></iframe></div></div><div id=modalCite class=modal><div class=modal-header><a ng-click=main.closeCiteModal() class=\"modal-action modal-close waves-effect waves-green btn-flat\"><i class=\"small material-icons\">close</i></a></div><div class=modal-content><h5>Cómo citar este contenido</h5><p class=citation-text>{{ main.citationText }}</p><button class=\"btn gire-button\" ng-click=main.copyCitation()>COPIAR CITA</button></div></div><div ui-view=indexBar class=index-bar ng-class=\"{\'topper-animate\': main.applyTopper}\"></div><!--<div ng-repeat=\"content in main.currentChap.subchapters\">\n  <p>\n  {{content.name}}\n  </p>\n  <p ng-bind-html=\"content.contentSanitized\">\n  </p>\n</div>--><div ng-if=main.currentChap.intro class=row><div class=\"col s8 offset-s2 subtitle-content\" style=margin-top:0><div ng-bind-html=main.currentChap.intro></div></div></div><div class=\"row breakpoint\" id=ch{{main.currentChap.num}}sub{{main.currentChap.subchapters[$index].num}} ng-repeat=\"content in main.currentChap.subchapters\"><div class=\"col s10 offset-s1\"><div class=\"row subtitle-container\"><div class=\"col s1 offset-s1\"><h2>{{content.formattedChapter}}</h2></div><div class=\"col s10\"><h4>{{content.name}}</h4><h5>{{main.currentChap.name}}<!--Must be updated--></h5></div></div></div><div class=container><div class=subtitle-content><!--<p>{{content.content}}</p>--><div ng-bind-html=content.content ng-init=main.renderCharts(content)></div><div class=cite-fixed ng-class=\"{ visible: main.applyTopper }\"><button class=\"btn gire-button citar-btn\" ng-click=main.openCiteModal(content)><h5 class=download-button>CITAR</h5></button></div></div></div></div>");
$templateCache.put("app/components/index-bar/index-bar.html","<div class=center-elements><!--<button class=\"rotate intro-button\">INTRO</button>--> <button class=index-bar-buttons ng-repeat=\"chapter in main.chapters\" ui-sref=main({chap:chapter.num,subchap:1}) ui-sref-opts=\"{reload: true}\"><span class=index-bar-number>{{chapter.num}}</span> <span class=index-bar-name>{{chapter.name}}</span></button></div><div class=\"row nav-index-bar center-elements\"><button id=arrow-back ng-click=\"main.updateChapter(\'goBack\')\" ng-hide=\"main.currentSubChap.first && main.currentChap.first\"></button><div class=\"index-bar-text-container center-elements\"><h2>{{main.currentSubChap.formattedChapter}}</h2><div class=titles-indexbar><h4>{{main.currentSubChap.name}}</h4><h5>{{main.currentChap.name}}</h5></div></div><!--<div class=\"col s1 offset-s1\">\n      <div id=\"arrow-back\" ng-click=\"main.updateChapter(\'goBack\')\" ng-hide=\"main.currentSubChap.first && main.currentChap.first\"></div>\n    </div>--><!--<div class=\"col s7 offset-s1\">\n      <div class=\"col s1\">\n        <h2>\n          {{main.currentSubChap.formattedChapter}}\n        </h2>\n      </div>\n      <div class=\"col s9\">\n        <h4>\n          {{main.currentSubChap.name}}\n        </h4>\n        <h5>\n          {{main.currentChap.name}}\n        </h5>\n      </div>\n    </div>--><!--<div class=\"col s1\">\n      <div id=\"arrow-forward\" ng-click=\"main.updateChapter(\'goForward\')\" ng-hide=\"main.currentSubChap.last && main.currentChap.last\"></div>\n    </div>--> <button id=arrow-forward ng-click=\"main.updateChapter(\'goForward\')\" ng-hide=\"main.currentSubChap.last && main.currentChap.last\"></button></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=https://github.com/Swiip/generator-gulp-angular><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/admin/admin.html","<div class=container><h2>Admin</h2></div><div ui-view></div>");
$templateCache.put("app/admin/edit/edit-chapter.html","<div class=row><form class=\"col s12\"><div class=row><div class=\"input-field col s6\"><input class=validate id=title type=text ng-model=vm.chapter.name><label for=title>Titulo</label></div><div class=\"input-field col s6\"><input class=validate id=chap_num type=number ng-model=vm.chapter.num><label for=chap_num>Número de capítulo</label></div></div><div class=row><h5>Subcapítulos</h5><div class=\"col s12\"><table><thead><tr><th>Titulo</th><th>Nombre del capítulo</th><th>Editar</th><th>Eliminar</th></tr></thead><tbody><tr ng-repeat=\"subchapter in vm.chapter.subchapters\"><td><span>{{subchapter.num}}</span></td><td><span>{{subchapter.name}}</span></td><td><button class=\"waves-effect waves-light btn\" ui-sref=\"edit-subchapter({chapterId:vm.chapter._id,subchapterId: $index})\"><spand>Editar</spand></button></td><td><button class=\"waves-effect waves-light btn\" ng-click=vm.delSubChap($index)><spand>Eliminar</spand></button></td></tr></tbody></table></div></div></form></div>");
$templateCache.put("app/admin/edit/edit-subchapter.html","<div class=row><form class=\"col s12\"><div class=row><div class=\"input-field col s6\"><input class=validate id=title type=text ng-model=vm.subchapter.name><label for=title>Titulo</label></div><div class=\"input-field col s6\"><input class=validate id=chap_num type=number ng-model=vm.subchapter.num><label for=chap_num>Número del subcapítulo</label></div></div><div class=row><div class=\"col s12\"><div ui-tinymce=vm.tinymceOptions ng-model=vm.subchapter.content></div></div></div><div class=row><button ng-click=vm.saveSubchap()></button></div></form></div>");
$templateCache.put("app/admin/edit/list-chapters.html","<table><thead><tr><th>Titulo</th><th>Nombre del capítulo</th><th>Número de subcapitulos</th><th>Editar</th><th>Eliminar</th></tr></thead><tbody><tr ng-repeat=\"chapter in vm.chapters\"><td><span>{{chapter.num}}</span></td><td><span>{{chapter.name}}</span></td><td><span>{{chapter.subchapters.length}}</span></td><td><button class=\"waves-effect waves-light btn\" ui-sref=\"edit-chapter({id: chapter._id})\"><spand>Editar</spand></button></td><td><button class=\"waves-effect waves-light btn\"><spand>Eliminar</spand></button></td></tr></tbody></table>");
$templateCache.put("app/components/charts/chart1/chart1.html","<div class=chart id=chart1><div class=\"row subtitle-container\"><h4>Horas dedicadas a la semana al trabajo no remunerado</h4><h5>(Doméstico y de cuidado)</h5></div><div class=\"row chart-content\"><div class=\"col s12 m8 l8 right-border\"><p>Selecciona dos tipos de trabajo no remunerado para comparar las horas dedicadas y los porcentajes de personas que reportaron dedicarles tiempo.</p></div><div class=\"col s12 m4 l4\"><div class=\"col s6\"><div class=\"square bg1\"></div><p>Mujeres</p></div><div class=\"col s6\"><div class=\"square bg2\"></div><p>Hombres</p></div></div><div class=\"col s12 m6 l6\"><div class=graghHeader><h1>TAREAS DEL HOGAR</h1></div><select ng-model=vm.selected1><option ng-repeat=\"opt in vm.drop1\" ng-value=opt.src>{{opt.name}}</option></select><img class=responsive-img ng-src={{vm.selected1}}></div><div class=\"col s12 m6 l6\"><div class=graghHeader><h1>CUIDADO DE PERSONAS</h1></div><select ng-model=vm.selected2><option ng-repeat=\"opt in vm.drop2\" ng-value=opt.src>{{opt.name}}</option></select><img class=responsive-img ng-src={{vm.selected2}}></div></div><div class=\"row footer\"><p class=source>Fuente: Encuesta Intercensal 2015, INEGI</p></div></div>");
$templateCache.put("app/components/charts/chart12/chart12.html","<div class=\"row subtitle-container\"><h4>GASTO PÚBLICO POR NIÑO EN CADA ETAPA DE LA</h4><h5>INFANCIA. GASTO PROMEDIO EN LOS PAÍSES DEL OCDE VS GASTO EN MÉXICO</h5></div><div class=\"row chart-content\"><div class=\"col s12 m12 l12 center\"><div ng-include=\"\'assets/images/cap3/09-grafica.svg\'\">Your browser does not support SVG</div></div></div><div class=\"row footer\"><p class=source></p></div>");
$templateCache.put("app/components/charts/chart17/chart17.html","<div class=\"row subtitle-container\"><h4>LICENCIAS DE MATERNIDAD OTORGADAS POR EL ISSSTE</h4><h5>POR AÑO (2011 - 2015)</h5></div><div class=\"row chart-content\"><div class=\"col s12 m12 l12 center\"><div ng-include=\"\'assets/images/cap4/17-grafica.svg\'\">Your browser does not support SVG</div></div></div><div class=\"row footer\"><p class=source>FUENTE: ISSSTE. SISTEMA DE ACCESO A LA INFORMACIÓN PÚBLICA, FOLIO 0063700103816.</p></div>");
$templateCache.put("app/components/charts/chart18/chart18.html","<div class=\"row subtitle-container\"><h4>DURACIÓN DE LICENCIA DE MATERNIDAD POR PAÍS</h4><!--h5--><div class=\"col s11\"><p>Pasa el cursor sobre cada pais para ver su valor, también puedes filtrar países para verelegír la duración de licencias de maternidad.</p></div><div class=\"col s1\"><a class=\"btn-floating btn-tiny waves-effect waves-light yellow darken-2\" ng-click=vm.showModal()><i class=\"tiny material-icons\">visibility</i></a></div></div><div class=modal-content id=modalFilter ng-show=\"vm.modal == true\"><div class=\"col s12\"><p>FILTRAR PAÍSES CUYA DURACIÓN DE SEMANAS DE LICENCIA SEA ENTRE:</p><input id=rangeSelector type=text name=rangeSelector><br></div><div class=\"col s12\"><a class=\"modal-action modal-close waves-effect btn-flat button-default\" ng-click=vm.closeModal()>ACEPTAR</a></div></div><div class=\"row chart-content\"><div class=\"col s12 m12 l12 center\"></div><div id=legend><div class=\"col s3 right-align\">{{vm.maxMin[0]}}</div><div class=\"col s6\">&nbsp;</div><div class=\"col s3 left-align\">{{vm.maxMin[1]}}</div><div class=\"col s12\">SEMANAS DE DURACIÓN</div></div></div><div class=\"row footer\"><p class=source>FUENTE: ORGANIZACIÓN INTERNACIONAL DEL TRABAJO<a href=HTTP://WWW.ILO.ORG/GLOBAL/ABOUT-THE-ILO/MULTIMEDIA/MAPS-AND-CHARTS/WCMS_241698/LANG--ES/INDEX.HTM><span>HTTP://WWW.ILO.ORG/GLOBAL/ABOUT-THE-ILO/MULTIMEDIA/MAPS-AND-CHARTS/WCMS_241698/LANG--ES/INDEX.HTM</span></a></p></div>");
$templateCache.put("app/components/charts/chart2/chart2.html","<div class=\"row subtitle-container\"><h4>PORCENTAJE DE TIEMPO DEDICADO AL TRABAJO NO REMUNERADO</h4><h5>VS PORCENTAJE DE POBLACIÓN QUE LO REALIZA, POR SEXO</h5></div><div class=\"row chart-content\"><div class=\"col s12 m12 l12 center\"><div class=switch><label>VER SOLO HOMBRES <input type=checkbox ng-model=vm.switch ng-change=vm.showWomen()><span class=lever></span>COMPARAR CON MUJERES</label></div><div ng-include=\"\'assets/images/cap1/grafica02.svg\'\" onload=vm.showWomen()>Your browser does not support SVG</div></div></div><div class=\"row footer\"><p class=source></p></div>");
$templateCache.put("app/components/charts/chart22/chart22.html","<div class=\"row subtitle-container\"><h4>ESTANCIAS DE CUIDADO INFANTIL NIÑAS Y NIÑOS</h4><h5>INSCRITOS O ATENDIDOS EN ISSSTE, IMSS Y SEDESOL</h5></div><div class=\"row chart-content\"><div class=\"col s4 center\"><button class=\"waves-effect waves-light btn-large button-default full\" ng-click=\"vm.sel = 1;\" ng-class=\"{active: vm.sel == 1}\">NÚMERO DE GUARDERÍAS</button></div><div class=\"col s4 center\"><button class=\"waves-effect waves-light btn-large button-default full\" ng-click=\"vm.sel = 2;\" ng-class=\"{active: vm.sel == 2}\">TOTAL DE NIÑAS Y NIÑOS</button></div><div class=\"col s4 center\"><button class=\"waves-effect waves-light btn-large button-default full\" ng-click=\"vm.sel = 3;\" ng-class=\"{active: vm.sel == 3}\">NIÑAS Y NIÑOS POR GUARDERÍA</button></div><div class=\"col s12 m12 l12 center\"><img class=responsive-img src=assets/images/cap4/22a-estatica.jpg ng-if=\"vm.sel == 1\"><img class=responsive-img src=assets/images/cap4/22b-estatica.jpg ng-if=\"vm.sel == 2\"><img class=responsive-img src=assets/images/cap4/22c-estatica.jpg ng-if=\"vm.sel == 3\"></div></div><div class=\"row footer\"><p class=source>FUENTE: SISTEMA DE ACCESO A LA INFORMACIÓN PÚBLICA, FOLIO 0064100491916, 0063700104016</p></div>");
$templateCache.put("app/components/charts/chart21/chart21.html","<div class=\"row subtitle-container\"><h4>PRINCIPALES INSTITUCIONES PÚBLICAS DE CUIDADO</h4><h5>INFANTIL Y SU NORMATIVA</h5></div><div class=\"row chart-content\"><div class=\"col s12 m12 l12 center\"><img class=responsive-img src=assets/images/cap4/21a-estatica.jpg></div></div><div class=\"row line-buttons\"><div class=\"col s3\" style=\"width: 20%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel1 = vm.panel1 == 1 ? 0 : 1\">{{vm.panel1 != 1 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 16%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel1 = vm.panel1 == 2 ? 0 : 2\">{{vm.panel1 != 2 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 18%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel1 = vm.panel1 == 3 ? 0 : 3\">{{vm.panel1 != 3 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 20%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel1 = vm.panel1 == 4 ? 0 : 4\">{{vm.panel1 != 4 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 24%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel1 = vm.panel1 == 5 ? 0 : 5\">{{vm.panel1 != 5 ? \'VER\' : \'CERRAR\'}}</button></div></div><div class=row id=panel1 ng-show=vm.panel1><div class=\"col s12\" ng-if=\"vm.panel1 == 1\"><p>- Ley Federal de los Trabajadores al Servicio del Estado Reglamentaria del apartado B del artículo 123 Constitucional (LFTSE) art. 43, 6, e)</p><p>- Ley del Instituto de Seguridad y Servicios Sociales de los Trabajadores del Estado (Ley ISSSTE), arts. 4,III, d); 196, IV; 199, II</p><p>- Reglamento de los Servicios de Atención para el Bienestar y Desarrollo Infantil del Instituto de Seguridad y Servicios Sociales de los Trabajadores del Estado (RSABDI-ISSSTE)</p></div><div class=\"col s12\" ng-if=\"vm.panel1 == 2\"><p>— Mujer trabajadora derechohabiente.</p><p>— Hombre trabajador derechohabiente que sea viudo, divorciado o Con la custodia o patria potestad de sus hijos (art. 201 LSS ; art. 2, IV RPSG - IMSS y 8.1.3 NSG .)</p><p>* La SCJN mediante la Sentencia de Amparo en Revisión 59/2016 determinó que estas disposiciones son inconstitucionales.</p></div><div class=\"col s12\" ng-if=\"vm.panel1 == 3\"><h6>PRESTACIÓN DIRECTA</h6><p>Guarderías que administra el IMSS de manera directa.</p><p>MADRES IMSS</p><p>ORDINARIO</p><h6>PRESTACIÓN INDIRECTA</h6><p>Guarderías administradas por terceros mediante un Contrato de Prestación o Convenio de Subrogación del Servicio de Guardería.</p><p>VECINAL COMUNITARIO ÚNICO</p><p>INTEGRADORA</p><p>EN EL CAMPO</p><p>REVERSIÓN DE CUOTAS<span class=sup>*</span></p></div><div class=\"col s12\" ng-if=\"vm.panel1 == 4\"><p>Las edades van de los 43 días a los 4 años.</p></div><div class=\"col s12\" ng-if=\"vm.panel1 == 5\"><p>GUARDERÍAS INTEGRADORAS: 10 HORAS DIARIAS DE LUNES A VIERNES</p><p>RESTO DE GUARDERÍAS: 9 HORAS DIARIAS DE LUNES A VIERNES</p></div></div><div class=row><div class=\"col s12 center\"><img class=responsive-img src=assets/images/cap4/21b-estatica.jpg></div></div><div class=\"row line-buttons\"><div class=\"col s3\" style=\"width: 20%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel2 = vm.panel2 == 1 ? 0 : 1\">{{vm.panel2 != 1 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 16%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel2 = vm.panel2 == 2 ? 0 : 2\">{{vm.panel2 != 2 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 18%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel2 = vm.panel2 == 3 ? 0 : 3\">{{vm.panel2 != 3 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 20%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel2 = vm.panel2 == 4 ? 0 : 4\">{{vm.panel2 != 4 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 24%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel2 = vm.panel2 == 5 ? 0 : 5\">{{vm.panel2 != 5 ? \'VER\' : \'CERRAR\'}}</button></div></div><div class=row id=panel2 ng-show=vm.panel2><div class=\"col s12\" ng-if=\"vm.panel2 == 1\"><p>— Ley Federal de los Trabajadores al Servicio del Estado Reglamentaria del apartado B del artículo 123 Constitucional ( LFTSE ) art. 43, 6, e).</p><p>— Ley del Instituto de Seguridad y Servicios Sociales de los Trabajadores del Estado (Ley ISSSTE ), arts. 4,III, d); 196, IV; 199, II.</p><p>— Reglamento de los Servicios de Atención para el Bienestar y Desarrollo Infantil del Instituto de Seguridad y Servicios Sociales de los Trabajadores del Estado ( RSABDI - ISSSTE ).</p></div><div class=\"col s12\" ng-if=\"vm.panel2 == 2\"><p>— Madres trabajadoras derechohabientes.</p><p>— Por excepción, padres trabajadores: divorciados, viudos o que por cualquier otra circunstancia tengan a su exclusivo cargo la custodia legal ( RSABDI - ISSSTE , art. 2, XIX).</p></div><div class=\"col s12\" ng-if=\"vm.panel2 == 3\"><h6>ESTANCIAS PROPIAS</h6><p>Guarderías que administra el IMSS de manera directa.</p><h6>ESTANCIAS DE PARTICIPACIÓN SOCIAL</h6></div><div class=\"col s12\" ng-if=\"vm.panel2 == 4\"><p>Las edades van de los 60 días a los 6 años.</p></div><div class=\"col s12\" ng-if=\"vm.panel2 == 5\"><p>De 7:00 a 15:00 horas.</p><p>De 7:30 a 16:00 horas.</p></div></div><div class=row><div class=\"col s12 center\"><img class=responsive-img src=assets/images/cap4/21c-estatica.jpg></div></div><div class=\"row line-buttons\"><div class=\"col s3\" style=\"width: 20%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel3 = vm.panel3 == 1 ? 0 : 1\">{{vm.panel3 != 1 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 16%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel3 = vm.panel3 == 2 ? 0 : 2\">{{vm.panel3 != 2 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 18%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel3 = vm.panel3 == 3 ? 0 : 3\">{{vm.panel3 != 3 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 20%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel3 = vm.panel3 == 4 ? 0 : 4\">{{vm.panel3 != 4 ? \'VER\' : \'CERRAR\'}}</button></div><div class=\"col s3\" style=\"width: 24%\"><button class=\"btn waves rounded-button\" ng-click=\"vm.panel3 = vm.panel3 == 5 ? 0 : 5\">{{vm.panel3 != 5 ? \'VER\' : \'CERRAR\'}}</button></div></div><div class=row id=panel3 ng-show=vm.panel3><div class=\"col s12\" ng-if=\"vm.panel3 == 1\"><p>— Reglas de Operación del Programa de Estancias Infantiles para Apoyar a Madres Trabajadoras. Éstas son emitidas cada año mediante Acuerdo de los titulares de la SEDESOL y la Secretaría de Salud.</p></div><div class=\"col s12\" ng-if=\"vm.panel3 == 2\"><p>— Madres.</p><p>— Padres solos que sean “los únicos responsables del cuidado de las niñas o niños.”</p><p>— Tutores que trabajan, buscan empleo o estudian, cuyo ingreso per cápita estimado por hogar no rebasa la LB y declaran que no tienen acceso a servicios de cuidado y atención infantil a través de instituciones públicas de seguridad social u otros medios ( ROPEI , art. 3.2. y 3.3).</p></div><div class=\"col s12\" ng-if=\"vm.panel3 == 3\"><h6>IMPULSO A LOS SERVICIOS DE CUIDADO Y ATENCIÓN INFANTIL</h6><p>Guarderías que son administradas por particulares mediante un Contrato de Prestación o Convenio de Subrogación del Servicio de Guardería.</p></div><div class=\"col s12\" ng-if=\"vm.panel3 == 4\"><p>Las edades van de 1 año a los 3 años 11 meses y de 1 año a los 5 años 11 meses.</p></div><div class=\"col s12\" ng-if=\"vm.panel3 == 5\"><p>8 HORAS DIARIAS, MÍNIMO<span class=sup>*</span></p></div></div><br><div class=\"row footer\"><p class=source>Fuente: Sistema de Acceso a la Información Pública (Folio. 006400 491916, 0063700104016)</p></div>");
$templateCache.put("app/components/charts/chart3/chart3.html","<div class=\"row subtitle-container\"><h4>PORCENTAJE DEL VALOR ECONÓMICO GENERADO</h4><h5>POR TRABAJO NO REMUNERADO VS PORCENTAJE DE POBLACIÓN QUE LO REALIZA, POR SEXO</h5></div><div class=\"row chart-content\"><div class=\"col s12 m12 l12 center\"><div class=switch><label>VER SOLO HOMBRES <input type=checkbox ng-model=vm.switch ng-change=vm.showWomen()><span class=lever></span>COMPARAR CON MUJERES</label></div><div ng-include=\"\'assets/images/cap1/grafica03.svg\'\" onload=vm.showWomen()>Your browser does not support SVG</div></div></div><div class=\"row footer\"><p class=source></p></div>");
$templateCache.put("app/components/charts/chart5/chart5.html","<div class=\"row subtitle-container\"><h4>MUJERES POR TIPO DE EMPLEO</h4><h5>(EMPLEADOS + DESEMPLEADOS) /POBLACIÓN</h5></div><div class=\"row chart-content\"><div class=\"col s12 m12 l12 center\"><div ng-include=\"\'assets/images/cap3/02 mujeres por tipo de empleo.svg\'\">Your browser does not support SVG</div></div></div><div class=\"row footer\"><p class=source>Fuente: Luis Pinedo, “El costo de las licencias parentales en México.”</p></div>");
$templateCache.put("app/components/charts/chart6/chart6.html","<div class=\"row subtitle-container\"><h4>HOMBRES POR TIPO DE EMPLEO</h4><h5>(EMPLEADOS + DESEMPLEADOS) /POBLACIÓN</h5></div><div class=\"row chart-content\"><div class=\"col s12 m12 l12 center\"><div ng-include=\"\'assets/images/cap3/03 hombres por tipo de empleo.svg\'\">Your browser does not support SVG</div></div></div><div class=\"row footer\"><p class=source>Fuente: Luis Pinedo, “El costo de las licencias parentales en México.”</p></div>");
$templateCache.put("app/components/charts/fixed/fixed.html","<div class=\"row subtitle-container\"><h4>{{vm.title}}<sup class=tooltippedGraph ng-if=vm.tooltiptext data-position=top data-tooltip={{vm.tooltiptext}}>{{vm.tooltipnum}}</sup></h4><h5>{{vm.subtitle}}</h5></div><div class=\"row chart-content\"><div class=\"col s12 m12 l12\"><img class=responsive-img ng-src={{vm.imageurl}}></div></div><div class=\"row footer\"><p class=source>{{vm.source}}</p></div>");
$templateCache.put("app/components/charts/chart4/chart4.html","<div class=\"row subtitle-container\"><h4>TASA DE ACTIVIDAD POR SEXO VS EDAD</h4><h5>(EMPLEADOS + DESEMPLEADOS) /POBLACIÓN</h5></div><div class=\"row chart-content\"><div class=\"col s12 m12 l12 center\"><div ng-include=\"\'assets/images/cap3/01-Tasa-de-actividad-por-sexo-vs-edad.svg\'\">Your browser does not support SVG</div></div></div><div class=\"row footer\"><p class=source>Fuente: Luis Pinedo, “El costo de las licencias parentales en México.”</p></div>");
$templateCache.put("app/components/charts/chart16/chart16.html","<div class=\"row subtitle-container\"><h4>LICENCIAS DE MATERNIDAD OTORGADAS POR EL IMSS</h4><h5>POR RANGO DE EDAD (2011 - 2015)</h5></div><div class=\"row chart-content\"><div class=\"col s12 m12 l12 center\"><img class=responsive-img src=assets/images/cap4/16-estatica-datos.jpg></div></div><div class=\"row footer\"><!--p.source FUENTE: IMSS SISTEMA DE ACCESO A LA INFORMACIÓN PÚBLICA, FOLIO 0064100491516.--></div>");}]);